export var OpportunityKind = /*#__PURE__*/ function(OpportunityKind) {
    OpportunityKind["StalePrice"] = "stale_price";
    OpportunityKind["RecurringAdhoc"] = "recurring_adhoc";
    OpportunityKind["CrossSell"] = "cross_sell";
    OpportunityKind["DiscountLeak"] = "discount_leak";
    return OpportunityKind;
}({});
export var OpportunityChurnRiskBand = /*#__PURE__*/ function(OpportunityChurnRiskBand) {
    OpportunityChurnRiskBand["Low"] = "low";
    OpportunityChurnRiskBand["Medium"] = "medium";
    OpportunityChurnRiskBand["InsufficientHistory"] = "insufficient_history";
    return OpportunityChurnRiskBand;
}({});
export var RevenueOpportunitiesSectionState = /*#__PURE__*/ function(RevenueOpportunitiesSectionState) {
    RevenueOpportunitiesSectionState["Hidden"] = "hidden";
    RevenueOpportunitiesSectionState["BuildingUp"] = "building_up";
    RevenueOpportunitiesSectionState["Active"] = "active";
    RevenueOpportunitiesSectionState["Done"] = "done";
    return RevenueOpportunitiesSectionState;
}({});
export var RevenueOpportunityListSort = /*#__PURE__*/ function(RevenueOpportunityListSort) {
    RevenueOpportunityListSort["Rank"] = "rank";
    RevenueOpportunityListSort["Client"] = "client";
    RevenueOpportunityListSort["Kind"] = "kind";
    RevenueOpportunityListSort["Subject"] = "subject";
    RevenueOpportunityListSort["EstAnnualImpact"] = "estAnnualImpact";
    RevenueOpportunityListSort["Confidence"] = "confidence";
    return RevenueOpportunityListSort;
}({});
export var RevenueOpportunityListDirection = /*#__PURE__*/ function(RevenueOpportunityListDirection) {
    RevenueOpportunityListDirection["Asc"] = "asc";
    RevenueOpportunityListDirection["Desc"] = "desc";
    return RevenueOpportunityListDirection;
}({});
export var RevenueOpportunityDismissalScope = /*#__PURE__*/ function(RevenueOpportunityDismissalScope) {
    RevenueOpportunityDismissalScope["Opportunity"] = "opportunity";
    RevenueOpportunityDismissalScope["Kind"] = "kind";
    RevenueOpportunityDismissalScope["KindService"] = "kind_service";
    return RevenueOpportunityDismissalScope;
}({});
export var RevenueOpportunityDismissalReason = /*#__PURE__*/ function(RevenueOpportunityDismissalReason) {
    RevenueOpportunityDismissalReason["AlreadyHandled"] = "already_handled";
    RevenueOpportunityDismissalReason["NotRelevantForClient"] = "not_relevant_for_client";
    RevenueOpportunityDismissalReason["NumbersLookOff"] = "numbers_look_off";
    RevenueOpportunityDismissalReason["NotRelevantForService"] = "not_relevant_for_service";
    RevenueOpportunityDismissalReason["KindTurnedOff"] = "kind_turned_off";
    return RevenueOpportunityDismissalReason;
}({});
export var RevenueOpportunityDismissalRejection = /*#__PURE__*/ function(RevenueOpportunityDismissalRejection) {
    RevenueOpportunityDismissalRejection["InvalidScope"] = "invalid_scope";
    RevenueOpportunityDismissalRejection["InvalidReason"] = "invalid_reason";
    RevenueOpportunityDismissalRejection["UnknownKind"] = "unknown_kind";
    RevenueOpportunityDismissalRejection["MissingOpportunityKey"] = "missing_opportunity_key";
    RevenueOpportunityDismissalRejection["MissingKind"] = "missing_kind";
    RevenueOpportunityDismissalRejection["MissingServiceKey"] = "missing_service_key";
    RevenueOpportunityDismissalRejection["KeyTooLong"] = "key_too_long";
    RevenueOpportunityDismissalRejection["ServiceLabelTooLong"] = "service_label_too_long";
    RevenueOpportunityDismissalRejection["InvalidCharacters"] = "invalid_characters";
    return RevenueOpportunityDismissalRejection;
}({});
